import { useState, useEffect } from 'react';
import itemsList from '../../../utils/updatedItemsList.js';
import {v4 as uuidv4} from 'uuid';

const useCityProfitsHeaderLogic = (itemsSelected, setItemsSelected) => {
  ////STATES/VARRIABLES
  const [input, setInput] = useState('');
  const [itemSelected, setItemSelected] = useState(null);
  const [canBeEnchated, setCanBeEnchanted] = useState({});
  const [hideQualityList, setHideQualityList] = useState(true);
  const [hideLocationList, setHideLocationList] = useState(true);
  const [hideEnchantList, setHideEnchantList] = useState(true);
  const [hideItemList, setHideItemList] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const locations = [
    'Martlock',
    'Lymhurst',
    'Thetford',
    'FortSterling',
    'Bridgewatch',
    'Caerleon',
    'ArthursRest',
    'MorganasRest',
    'MerlynsRest',
  ];
  const enchants = ['@1', '@2', '@3'];
  let filteredSearches = itemsList.filter(item =>
    item.itemName.toLocaleLowerCase().includes(input)
  );
  function sortArray(x, y){
    if (x.itemName < y.itemName) {return -1;}
    if (x.itemName > y.itemName) {return 1;}
    return 0;
}
  let sortedSearches = filteredSearches.sort(sortArray);

  ////FUNCTIONS
  function handleSearch(item) {
      setItemsSelected(prevState => [
        ...prevState,
        {
          itemId: item.itemId,
          itemEnchant: "",
          quality: 1,
          itemLocation: "Martlock",
          canEnchant: item.canEnchant,
          id: uuidv4()
        },
      ]);
      setItemSelected(null);
      setInput('');
  }
  function selectItem(item) {
    setCanBeEnchanted(item.canEnchant);
    setItemSelected(item);
    setInput(item.itemName);
    setHideItemList(true);
  }

  function searchItem(item) {
    setInput(item.toLocaleLowerCase());
    setHideItemList(false);
  }

  function formatLocation(locationSelected) {
    switch (true) {
      case locationSelected.includes('Fort'):
        return 'Fort ' + locationSelected.split('Fort')[1];
      case locationSelected.includes('R'):
        return (
          locationSelected
            .split('R')[0]
            .substring(0, locationSelected.split('R')[0].length - 1) +
          "'s " +
          locationSelected.substring(
            locationSelected.length - 4,
            locationSelected.length
          )
        );
      default:
        return locationSelected;
    }
  }
  useEffect(() => {
    function validateSearch() {
      if (itemSelected === null) {
        setDisableButton(true);
      } else {
        setDisableButton(false);
      }
    }
    validateSearch();
  }, [itemSelected, disableButton]);

  return {
    //STATES
    input,
    itemSelected,
    canBeEnchated,
    hideLocationList,
    hideEnchantList,
    hideItemList,
    disableButton,
    hideQualityList,
    //SET STATES
    setInput,
    setItemSelected,
    setCanBeEnchanted,
    setHideLocationList,
    setHideEnchantList,
    setHideItemList,
    setDisableButton,
    setHideQualityList,
    //VARIABLES
    locations,
    enchants,
    filteredSearches,
    sortedSearches,
    //FUNCTIONS
    searchItem,
    selectItem,
    formatLocation,
    handleSearch,
  };
};
export default useCityProfitsHeaderLogic;
